export enum TemplatesColumns {
    Name = 'name',
    Updated = 'updated',
    UsedIn = 'usedIn'
}
